import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBy'
})
export class FilterByPipe implements PipeTransform {

  transform(values: any, args?: any): any {
    if (values && args) {
      let exp = '';
      const items = Object.values(args);
      items.forEach((a, i) => {
        exp += '(';
        a['values'].forEach((v, j) => {
          j === 0 ? exp += '(v.' +  a['attribute'] + '===\'' + v + '\')' : exp += '|| (v.' +  a['attribute'] + '===\'' + v + '\') ' ;
        });
        i === (items.length - 1) ? exp += ') ' : exp += ') && ';
      });
      return values.filter(v => eval(exp));
    }
    return values;
  }

}
